import { api } from "@astro/api";
import { appUrl } from "@astro/config";
import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { Link, useNavigate } from "react-router-dom";

const CATEGORY_SLUG = "gemstone"

export default function GemstoneCategoriesSection() {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["shopByGemstoneCategory"],
    queryFn: () => api.catalog.categories(CATEGORY_SLUG),
    placeholderData: keepPreviousData
  });

  const stoneCategory = (data?.data || []);


  return (
    <section id="category-gemstone" className="relative overflow-hidden scroll-mt-24 py-16 md:py-24 md:px-16 bg-linear-to-b from-background to-white normal-case select-none">
      <div className="pointer-events-none absolute inset-0 opacity-[0.45]">
        <div className="absolute -left-24 top-10 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.12),transparent_70%)] blur-3xl animate-pulse" />
        <div className="absolute -right-24 bottom-0 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(123,13,30,0.09),transparent_70%)] blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
      </div>

      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between border-b border-gray-100 pb-6 mb-12">
          <div className="max-w-xl text-left">
            <span className="inline-flex items-center gap-2 text-[10px] font-bold tracking-[0.35em] text-secondary mb-2 uppercase"><i className="fa-solid fa-gem text-[9px]"></i> SACRED RATNA</span>
            <h2 className="font-heading text-2xl md:text-3xl text-[#2B0B14] font-normal leading-tight tracking-tight uppercase">Explore Gemstone Categories</h2>
          </div>
          {/* Stacked and full-width on phones — these were `hidden md:flex`,
              so mobile had no way into the category at all. */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 shrink-0">
            <Link
              to={CATEGORY_SLUG}
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#2B0B14] px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-white shadow-lg shadow-[#2B0B14]/20 transition-all duration-300 hover:bg-secondary"
            >
              View All Gemstones <i className="fa-solid fa-arrow-right w-3.5 h-3.5 transition-transform group-hover:translate-x-1"></i>
            </Link>
            <a
              href={appUrl("jyotish")}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-[#2B0B14]/25 px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#2B0B14] transition-all duration-300 hover:border-secondary hover:text-secondary"
            >
              <i className="fa-solid fa-comment-dots"></i> Consult an Astrologer
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 sm:gap-5">
          {isLoading
            ? Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="flex h-full flex-col items-center rounded-3xl border border-gray-200 bg-white px-4 py-6 animate-pulse">
                <div className="h-20 w-20 md:h-24 md:w-24 rounded-full bg-gray-200" />
                <div className="mt-4 h-4 w-24 rounded bg-gray-200" />
                <div className="mt-2 h-3 w-16 rounded bg-gray-100" />
                <div className="mt-4 h-3 w-20 rounded bg-gray-100" />
              </div>
            ))
            : stoneCategory?.map((g) => (
              <div
                key={g.slug}
                className="group relative flex h-full flex-col items-center rounded-3xl border border-gray-200 bg-white px-4 py-6 text-center shadow-sm transition-all duration-500 hover:-translate-y-2 hover:border-secondary/50 hover:shadow-2xl hover:shadow-[#2B0B14]/5 cursor-pointer"
                onClick={() => navigate(g.slug)}
              >
                <i className="fa-solid fa-arrow-up-right absolute right-4 top-4 text-gray-300 text-xs opacity-0 group-hover:opacity-100 group-hover:text-secondary transition-all duration-300"></i>
                <div className="relative h-20 w-20 md:h-24 md:w-24 flex items-center justify-center">
                  <div className="absolute w-full h-full rounded-full opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-500" style={{ background: `radial-gradient(circle, ${g.glow} 0%, transparent 70%)` }}></div>
                  <img alt={g.name} className="w-full h-full object-contain transform group-hover:scale-110 transition duration-500" src={g.image_url} />
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold leading-tight text-[#2B0B14] transition-colors group-hover:text-secondary">{g.name}</h3>
                <p className="mt-1 text-[11px] font-medium uppercase tracking-[0.18em] text-gray-400">{g.sub}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.2em] opacity-0 transform translate-y-1 group-hover:opacity-70 group-hover:translate-y-0 transition-all duration-300 text-[#2B0B14]">Shop Now <i className="fa-solid fa-arrow-right text-[9px]"></i></span>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  )
}
